<template>
	<div class="container page" style="background-color: #1f1c1f;">
		<van-nav-bar :title="$t('setting.language')" class="nav-bar custom-nav" :border="false">
			<template #left>
				<van-icon name="arrow-left" color="#e6b98a" size="24" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="items">
			<div class="item van-hairline--bottom" @click="changeLang('zh', $event)">
				<div class="flex_center">
					<img src="/img/zh_cn.png" alt="" class="ja_h" />
					<div class="info">简体中文</div>
				</div>
				<div v-if="lang == 'zh'">✓</div>
			</div>
			<div class="item van-hairline--bottom" @click="changeLang('en', $event)">
				<div class="flex_center">
					<img src="/img/en_us.png" alt="" class="ja_h" />
					<div class="info">English</div>
				</div>
				<div v-if="lang == 'en'">✓</div>
			</div>
			<div class="item van-hairline--bottom" @click="changeLang('ja', $event)">
				<div class="flex_center">
					<img src="/img/ja.png" alt="" class="ja_h" />
					<div class="info">日本語</div>
				</div>
				<div v-if="lang == 'ja'">✓</div>
			</div>
			<div class="item van-hairline--bottom" @click="changeLang('es', $event)">
				<div class="flex_center">
					<img src="/img/es_spa.png" alt="" class="ja_h" />
					<div class="info">Español</div>
				</div>
				<div v-if="lang == 'es'">✓</div>
			</div>
			<div class="item van-hairline--bottom" @click="changeLang('pr', $event)">
				<div class="flex_center">
					<img src="/img/istockphoto-2209323943-612x612.jpg" alt="" class="ja_h" />
					<div class="info">Português</div>
				</div>
				<div v-if="lang == 'pr'">✓</div>
			</div>
			<div class="item van-hairline--bottom" @click="changeLang('de', $event)">
				<div class="flex_center">
					<img src="/img/de_DE.png" alt="" class="ja_h" />
					<div class="info">Deutsch</div>
				</div>
				<div v-if="lang == 'de'">✓</div>
			</div>
			<div class="item van-hairline--bottom" @click="changeLang('it', $event)">
				<div class="flex_center">
					<img src="/img/it_IT.png" alt="" class="ja_h" />
					<div class="info">Italiano</div>
				</div>
				<div v-if="lang == 'it'">✓</div>
			</div>
			<div class="item van-hairline--bottom" @click="changeLang('kr', $event)">
				<div class="flex_center">
					<img src="/img/ms_my.png" alt="" class="ja_h" />
					<div class="info">한국어</div>
				</div>
				<div v-if="lang == 'kr'">✓</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Toast
	} from "vant";
	export default {
		name: "Language",
		data() {
			return {
				lang: this.$i18n.locale || "en",
				source: ''
			};
		},
		created() {
			this.replaceLang()
		},
		mounted() {
			this.source = this.$route.params.type
		},
		methods: {
			back() {
				return window.history.back();
			},
			replaceLang() {
				this.$http({
					method: "get",
					url: "replaceLang",
					data: {
						lang: this.lang,
					},
				}).then((res) => {
					console.log(res, 11)
				});
			},
			changeLang(lang) {

				Toast.loading({
					// mask: true,
					duration: 200,
				});
				this.lang = lang;
				this.$i18n.locale = lang;
				this.replaceLang()
				localStorage.setItem("lang", lang);

				if (this.source == 'setting') {
					this.$router.push({
						path: '/'
					});
				} else {
					this.$router.go(-1);
				}
			},
		}

	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.nav-bar {
		background: #2b2b2b;
		border-bottom: 2px solid #766350;
	}

	::v-deep .nav-bar .van-nav-bar__title {
		color: #e6b98a !important;
		font-size: 36px;
	}

	.container .items {
		background: #2b2b2b;
		font-size: 32px;
		color: #f3c7a2;
		padding: 30px;
		margin: 30px 20px;
		border-radius: 20px;
		border: 2px solid #766350;
	}

	.container .items .item {
		padding: 30px 0;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		border-bottom: 2px solid #3a3a3a;
	}

	.container .items .item:last-child {
		border-bottom: none;
	}

	.container .items .van-hairline--bottom::after {
		display: none;
	}

	.container .sign-out {
		margin: 500px 20px 0;
		height: 100px;
		line-height: 100px;
		border-radius: 50px;
		color: #fff;
		font-size: 40px;
		font-weight: bolder;
		border: none;
		background: linear-gradient(270deg, #e6c3a1, #7e5678);
	}

	.container .item .desc {
		font-size: 30px;
		font-weight: 700;
		color: #979799;
	}

	.container .item .right {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.flex_center {
		display: flex;
		align-items: center;
	}

	.flex_center img {
		width: 60px;
		height: auto;
		margin-right: 20px;
	}
</style>